import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.recipe.sortFields,
	columnFields: constants.wholeHouse.recipe.columnFields,
	standardFilterFields: constants.wholeHouse.recipe.osStandardFilterFields,
	dateFilterFields: constants.wholeHouse.recipe.osDateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
